export const messages = {
  title: { id: 'admin/promotions.form.conditions.subscription.title' },
  type: {
    label: { id: 'admin/promotions.form.conditions.subscription.type.label' },
    all: {
      label: {
        id: 'admin/promotions.form.conditions.subscription.type.all.label',
      },
      description: {
        id: 'admin/promotions.form.conditions.subscription.type.all.description',
      },
    },
    first: {
      label: {
        id: 'admin/promotions.form.conditions.subscription.type.first.label',
      },
      description: {
        id: 'admin/promotions.form.conditions.subscription.type.first.description',
      },
    },
    recurring: {
      label: {
        id: 'admin/promotions.form.conditions.subscription.type.recurring.label',
      },
      description: {
        id: 'admin/promotions.form.conditions.subscription.type.recurring.description',
      },
    },
  },
  editor: {
    subtitle: { id: 'admin/promotions.form.conditions.subscription.subtitle' },
    filter: {
      id: 'admin/promotions.form.conditions.subscription.filter',
    },
    frequency: {
      label: {
        id: 'admin/promotions.form.conditions.subscription.frequency.label',
      },
      value: {
        id: 'admin/promotions.form.conditions.subscription.frequency.value',
      },
      unit: {
        day: {
          id: 'admin/promotions.form.conditions.subscription.frequency.day',
        },
        week: {
          id: 'admin/promotions.form.conditions.subscription.frequency.week',
        },
        month: {
          id: 'admin/promotions.form.conditions.subscription.frequency.month',
        },
        year: {
          id: 'admin/promotions.form.conditions.subscription.frequency.year',
        },
      },
    },
    cycle: {
      label: {
        id: 'admin/promotions.form.conditions.subscription.cycle.label',
      },
      operator: {
        equals: {
          id: 'admin/promotions.form.conditions.subscription.cycle.equals',
        },
        greaterThan: {
          id: 'admin/promotions.form.conditions.subscription.cycle.greaterThan',
        },
        lessThan: {
          id: 'admin/promotions.form.conditions.subscription.cycle.lessThan',
        },
        range: {
          id: 'admin/promotions.form.conditions.subscription.cycle.range',
        },
      },
    },
  },
  view: {
    title: { id: 'admin/promotions.form.conditions.subscription.view.title' },
    detail: {
      frequency: {
        id: 'admin/promotions.form.conditions.subscription.view.detail.frequency',
      },
    },
    frequency: {
      label: {
        id: 'admin/promotions.form.conditions.subscription.frequency.label',
      },
      value: {
        id: 'admin/promotions.form.conditions.subscription.frequency.value',
      },
      unit: {
        day: {
          id: 'admin/promotions.utils.day',
        },
        week: {
          id: 'admin/promotions.utils.week',
        },
        month: {
          id: 'admin/promotions.utils.month',
        },
        year: {
          id: 'admin/promotions.utils.year',
        },
      },
    },
    cycle: {
      equals: {
        id: 'admin/promotions.form.conditions.subscription.view.cycle.equals',
      },
      greaterThan: {
        id: 'admin/promotions.form.conditions.subscription.view.cycle.greater-than',
      },
      lessThan: {
        id: 'admin/promotions.form.conditions.subscription.view.cycle.less-than',
      },
      range: {
        id: 'admin/promotions.form.conditions.subscription.view.cycle.range',
      },
    },
  },
  validation: {
    required: { id: 'admin/promotions.form.validation.required' },
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    greaterThanMin: {
      id: 'admin/promotions.form.validation.max-greater-than-min',
    },
  },
}
